import React from "react";

const MinusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={props.width || "14"}
      height={props.height || "2"}
      viewBox="0 0 14 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0H14V2H0V0Z" fill="#3A8AB9" />
    </svg>
  );
};

export default MinusIcon;
